import React, { useState } from 'react';
import Snowflake from './Snowflake';
import Info1 from './img/Info_1.png';
import Info2 from './img/Info_2.png';
import Info3 from './img/Info_3.png';
import Info4 from './img/Info_4.png';
import './Info.css';

const Info = () => {
  const [activeTab, setActiveTab] = useState(0);

  const snowflakes = Array.from({ length: 30 }).map((_, index) => <Snowflake key={index} />);

  return (
    <div className="content-container">
      <div className="row">
        <img className="image1" src={Info1} alt="Info_1" />
        <div className="text1">
        Hello, I’m Loesuy, a Korean tattoo artist based in Paris, France. I work with both handpoke and machine techniques.
        </div>
      </div>

      <div className="row reverse">
        <img className="image2" src={Info2} alt="Info_2" />
        <div className="text2">
        I offer both handpoke and machine tattoos. I choose the technique that best suits each design and placement. If you specifically prefer a handpoke tattoo, please let me know in advance. 
        </div>
      </div>
      <div className="text3">
      My work is mainly inspired by women, ornamental designs, flowers, and animals. You can explore available designs in the Design section or contact me about a custom project.
      </div>
      <div className="row">
        <img className="image3" src={Info3} alt="Info_3" />
        <div className="text4">
        Most of my flash designs are tattooed only once. However, some designs are available for multiple tattoos. If you’re interested in a specific design, feel free to ask if it’s still available.
        </div>
      </div>
      <div>
        <img className="image4" src={Info4} alt="Info_4" />        
      </div>
      <div className="text5 blinking-text-Info">
          <span className='new-line2'>Thank you for considering me as your tattoo artist.</span>
          <span className='new-line2'> I look forward to working with you!</span>
          <span className='new-Noline'>See you soon!</span> 
        </div>
      {snowflakes}
    </div>
  );
};

export default Info;
